module.exports = __webpack_public_path__ + "img/worm-preparing-mask.8e6db1c3.png";